module.exports = __webpack_public_path__ + "src/theme/fonts/grotesk/AktivGroteskGeberit_W_Md.ttf";